import styled from 'styled-components'

const ConfirmContainer = styled.div`
	padding-top: 88px;
	min-height: 75vh;
`

export default ConfirmContainer